import { __assign, __rest } from "tslib";
// DS3.1.1 / Search
import React from 'react';
import c from 'classnames';
import TextInput from '../TextInput';
import SearchIcon from '../../../Icons/24x24/Search';
import CloseIcon from '../../../Icons/24x24/Close';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import s from './SearchInput.scss';
var SearchInput = React.forwardRef(function (_a, ref) {
    var onClearClick = _a.onClearClick, value = _a.value, disabled = _a.disabled, rest = __rest(_a, ["onClearClick", "value", "disabled"]);
    var prefix = (React.createElement("span", { className: s['search-icon'] },
        React.createElement(SearchIcon, null)));
    var postfix = value ? (React.createElement(PlainButtonOrLink, { className: s['clear-btn'], onClick: onClearClick },
        React.createElement(CloseIcon, null))) : null;
    return (React.createElement(TextInput, __assign({ ref: ref, prefix: prefix, postfix: postfix, value: value, disabled: disabled, className: c(!value && s['empty'], disabled && s['disabled']) }, rest)));
});
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map